<template>
  <div>
    <!-- MOVIE DETAILS DESK BANNER -->
    <section>
      <div class="container-fluid px-0">
        <div
          class="movieDetailBanner d-none d-md-block"
          :style="{
            background:
              'linear-gradient(1.01deg, rgba(0, 0, 0, 0.71) 8.89%, rgba(0, 0, 0, 0) 97.25%), linear-gradient(358.63deg, rgba(0, 0, 0, 0.25) 40.97%, rgba(0, 0, 0, 0) 97.07%), url(' +
              poster +
              ')',
          }"
        >
          <!-- BACKGROUND IMAGE -->
          <a
            :href="movieDetails.original_trailer"
            data-fancybox
            class="play-icon"
          >
            <img src="@/assets/img/svg/play-icon.svg" class="img-fluid" />
          </a>
          <div class="banner-content w-100">
            <div class="d-md-flex align-items-center pl-md-5">
              <div class="movieDetails text-white mb-0 mb-lg-3">
                <p class="mTitle">{{ movieDetails.mc_title }}</p>
                <ul class="list-inline mInfo">
                  <!-- <li class="list-inline-item">{{ movieDetails.Lang }}</li> -->
                  <li class="list-inline-item">
                    {{ movieDetails.mrrdr_runtime }} mins
                  </li>
                  <li class="list-inline-item">
                    {{ GetYear(movieDetails.mrrdr_release_date) }}
                  </li>
                  <li class="list-inline-item">
                    {{ movieDetails.rating }}
                  </li>
                  <!-- <li v-for="(directorName, directorKey2) in movieDetails.Directors" :key="directorKey2" class="list-inline-item">{{directorName.Name}}</li> -->
                </ul>
              </div>
            </div>
            <div class="d-flex align-items-center pl-3 pl-md-5">
              <!-- DIRECTOR LISTING IMAGES -->
              <!-- <div class="director-listing pr-2 pr-lg-4">
                <ul class="list-inline mb-0">
                  <li v-for="(director, directorKey1) in movieDetails.Directors" :key="directorKey1" class="list-inline-item">
                    <img :src="director.Image" class="img-fluid">
                  </li>
                </ul>
              </div>-->

              <!-- ACTOR LISTING IMAGES-->
              <!-- <div class="actor-listing mx-2 mx-lg-3 mx-xl-4">
                <ul class="list-inline mb-0">
                   <li v-for="(actor, actorKey) in movieDetails.Actors" :key="actorKey" class="list-inline-item">
                    <img :src="actor.Image" class="img-fluid">
                  </li>
                </ul>
              </div>-->
              <!-- IMDB RATING -->
              <!-- <div class="mr-3">
                <p class="small mb-1 text-white">IMDB</p>
                <ul class="list-inline imdb mb-0">
                  <li class="list-inline-item mx-0">
                    {{ movieDetails.IMDBRating }}
                  </li>

                </ul>
              </div> -->
              <!-- <li class="list-inline-item mx-0">/</li> -->
              <!-- <li class="list-inline-item mx-0">10</li> -->
              <!-- GENERAL RATING  -->
              <!-- <div class="mx-2 mx-lg-3 mx-xl-4">
                <p class="small mb-1 text-white">Rating</p>
                <ul class="list-inline g-rating mb-0">
                  <li class="list-inline-item mx-0">{{movieDetails.Rated}}</li>
                </ul>
              </div>-->
              <!-- FAVOURITE BUTTON -->
              <!-- <div class="mx-2 mx-lg-3 mx-xl-4">
                <router-link to="" tabindex="0">
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M3.03647 16.9155C2.03317 22.7061 6.21478 25.7129 11.4651 22.9797L12.4999 22.4411L13.5347 22.9797C18.7862 25.7137 22.9666 22.7046 21.9633 16.9155L21.7658 15.7749L22.6031 14.967C26.8514 10.8661 25.2531 5.99955 19.3836 5.15501L18.2264 4.98865L17.709 3.95082C15.0833 -1.31761 9.91533 -1.31627 7.29077 3.95082L6.77337 4.98865L5.61619 5.15501C-0.25453 5.99985 -1.85035 10.8672 2.39669 14.967L3.23398 15.7749L3.03647 16.9155ZM14.4435 21.2669L12.4999 20.2549L10.5563 21.2669C6.73944 23.2535 4.23242 21.4531 4.96187 17.2427L5.33386 15.0993L3.76107 13.5814C0.673638 10.6016 1.62846 7.68443 5.89731 7.07014L8.07111 6.75731L9.0429 4.80718C10.9501 0.979014 14.0472 0.976471 15.9569 4.80718L16.9287 6.75731L19.1025 7.07014C23.3677 7.68398 24.3274 10.5995 21.2387 13.5814L19.6659 15.0993L20.0367 17.2427C20.7662 21.4503 18.2616 23.2547 14.4435 21.2669Z"
                      fill="white"></path>
                  </svg>
                </router-link>
              </div>-->
              <!-- SHARE BUTTON -->
              <!-- <div class="mx-2 mx-lg-3 mx-xl-4">
                <router-link to="" tabindex="0">
                  <svg width="18" height="21" viewBox="0 0 18 21" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M18 3.9375C18 6.10907 16.2246 7.875 14.0399 7.875C12.7203 7.875 11.5438 7.23066 10.8244 6.25232L7.34389 8.49551C7.70424 9.09205 7.9202 9.78404 7.9202 10.5238C7.9202 10.8709 7.87626 11.2081 7.79088 11.5287C7.68917 11.9135 7.52972 12.2745 7.32003 12.5999L10.7515 14.8909C11.4484 13.817 12.6726 13.125 14.0399 13.125C16.2246 13.125 18 14.8909 18 17.0625C18 19.2341 16.2246 21 14.0399 21C11.8564 21 10.0798 19.2341 10.0559 17.0625C10.0559 17.0148 10.0622 16.9612 10.0672 16.9075C10.0735 16.8538 10.0798 16.8001 10.0798 16.7523L5.87988 13.9364C5.32743 14.2466 4.65569 14.4375 3.9601 14.4375C1.77539 14.4375 0 12.6716 0 10.5C0 8.32843 1.77539 6.5625 3.9601 6.5625C4.67955 6.5625 5.3764 6.7534 5.95145 7.08756L10.1037 4.41476C10.1037 4.346 10.0986 4.27166 10.0924 4.19445L10.0823 4.0616L10.0798 3.9375C10.0798 1.76593 11.8564 0 14.0399 0C16.2246 0 18 1.76593 18 3.9375ZM16.079 3.9375C16.079 2.8159 15.1674 1.90904 14.0399 1.90904C12.9111 1.90904 11.9996 2.8159 11.9996 3.9375C11.9996 5.0591 12.9111 5.96581 14.0399 5.96581C15.1674 5.96581 16.079 5.0591 16.079 3.9375ZM14.0399 15.034C15.1674 15.034 16.079 15.9409 16.079 17.0625C16.079 18.1841 15.1674 19.0908 14.0399 19.0908C12.9111 19.0908 11.9996 18.1841 11.9996 17.0625C11.9996 15.9409 12.9111 15.034 14.0399 15.034ZM1.91978 10.5C1.91978 11.6216 2.83133 12.5283 3.9601 12.5283C5.08761 12.5283 5.99916 11.6216 5.99916 10.5C5.99916 9.3784 5.08761 8.47154 3.9601 8.47154C2.83133 8.47154 1.91978 9.3784 1.91978 10.5Z"
                      fill="white"></path>
                  </svg>
                </router-link>
              </div>-->
              <!-- <div class="ml-auto btn-cos-container">
                <router-link to=""><img src="@/assets/img/svg/Create-your-own-Screening.svg" class="img-fluid cs-img">
                </router-link>
              </div>-->
            </div>
          </div>
        </div>
        <!-- MOVIE DETAILS MOBILE BANNER -->
        <div
          class="movieDetailBanner d-block d-md-none"
          :style="{
            background:
              'linear-gradient(1.01deg, rgba(0, 0, 0, 0.71) 8.89%, rgba(0, 0, 0, 0) 97.25%), linear-gradient(358.63deg, rgba(0, 0, 0, 0.25) 40.97%, rgba(0, 0, 0, 0) 97.07%), url(' +
              poster +
              ')',
          }"
        >
          <!-- BACKGROUND IMAGE -->
          <a
            :href="movieDetails.original_trailer"
            data-fancybox
            class="play-icon"
          >
            <img src="@/assets/img/svg/play-icon.svg" class="img-fluid" />
          </a>
          <div class="banner-content w-100 py-2 py-xl-4">
            <div
              class="
                d-md-flex
                align-items-center
                text-center text-md-left
                pl-xl-5
              "
            >
              <div class="movieDetails text-white mb-3">
                <p class="mTitle">{{ movieDetails.mc_title }}</p>
                <ul class="list-inline mInfo">
                  <!-- <li class="list-inline-item">{{ movieDetails.Lang }}</li> -->
                  <li class="list-inline-item">
                    {{ movieDetails.mrrdr_runtime }}
                  </li>
                  <li class="list-inline-item">
                    {{ GetYear(movieDetails.mrrdr_release_date) }}
                  </li>
                  <li class="list-inline-item">{{ movieDetails.rating }}</li>
                  <!-- <li v-for="(directorName, directorKey2) in movieDetails.Directors" :key="directorKey2" class="list-inline-item">{{directorName.Name}}</li> -->
                </ul>
              </div>
            </div>
            <div
              class="
                d-md-flex
                align-items-center
                text-center text-md-left
                pl-xl-5
              "
            >
              <!-- DIRECTOR LISTING IMAGES -->
              <!-- <div class="director-listing pr-2 pr-lg-4">
                <ul class="list-inline mb-0">
                  <li v-for="(director, directorKey1) in movieDetails.Directors" :key="directorKey1" class="list-inline-item">
                    <img :src="director.Image" class="img-fluid">
                  </li>
                </ul>
              </div>-->

              <!-- ACTOR LISTING IMAGES-->
              <!-- <div class="actor-listing mx-2 mx-lg-3 mx-xl-4">
                <ul class="list-inline mb-0">
                   <li v-for="(actor, actorKey) in movieDetails.Actors" :key="actorKey" class="list-inline-item">
                    <img :src="actor.Image" class="img-fluid">
                  </li>
                </ul>
              </div>-->

              <!-- IMDB RATING -->
              <!-- <div class="text-center text-md-left">
                <p class="small mb-1 text-white">IMDB</p>
                <ul class="list-inline imdb mb-0">
                  <li class="list-inline-item mx-0">
                    {{ movieDetails.IMDBRating }}
                  </li>

                </ul>
              </div> -->
              <!-- GENERAL RATING  -->
              <!-- <div class="mx-2 mx-lg-3 mx-xl-4">
                <p class="small mb-1 text-white">Rating</p>
                <ul class="list-inline g-rating mb-0">
                  <li class="list-inline-item mx-0">{{movieDetails.Rated}}</li>
                </ul>
              </div>-->

              <!-- FAVOURITE BUTTON -->
              <!-- <div class="mx-2 mx-lg-3 mx-xl-4">
                <router-link to="" tabindex="0">
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M3.03647 16.9155C2.03317 22.7061 6.21478 25.7129 11.4651 22.9797L12.4999 22.4411L13.5347 22.9797C18.7862 25.7137 22.9666 22.7046 21.9633 16.9155L21.7658 15.7749L22.6031 14.967C26.8514 10.8661 25.2531 5.99955 19.3836 5.15501L18.2264 4.98865L17.709 3.95082C15.0833 -1.31761 9.91533 -1.31627 7.29077 3.95082L6.77337 4.98865L5.61619 5.15501C-0.25453 5.99985 -1.85035 10.8672 2.39669 14.967L3.23398 15.7749L3.03647 16.9155ZM14.4435 21.2669L12.4999 20.2549L10.5563 21.2669C6.73944 23.2535 4.23242 21.4531 4.96187 17.2427L5.33386 15.0993L3.76107 13.5814C0.673638 10.6016 1.62846 7.68443 5.89731 7.07014L8.07111 6.75731L9.0429 4.80718C10.9501 0.979014 14.0472 0.976471 15.9569 4.80718L16.9287 6.75731L19.1025 7.07014C23.3677 7.68398 24.3274 10.5995 21.2387 13.5814L19.6659 15.0993L20.0367 17.2427C20.7662 21.4503 18.2616 23.2547 14.4435 21.2669Z"
                      fill="white"></path>
                  </svg>
                </router-link>
              </div>-->

              <!-- SHARE BUTTON -->
              <!-- <div class="mx-2 mx-lg-3 mx-xl-4">
                <router-link to="" tabindex="0">
                  <svg width="18" height="21" viewBox="0 0 18 21" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M18 3.9375C18 6.10907 16.2246 7.875 14.0399 7.875C12.7203 7.875 11.5438 7.23066 10.8244 6.25232L7.34389 8.49551C7.70424 9.09205 7.9202 9.78404 7.9202 10.5238C7.9202 10.8709 7.87626 11.2081 7.79088 11.5287C7.68917 11.9135 7.52972 12.2745 7.32003 12.5999L10.7515 14.8909C11.4484 13.817 12.6726 13.125 14.0399 13.125C16.2246 13.125 18 14.8909 18 17.0625C18 19.2341 16.2246 21 14.0399 21C11.8564 21 10.0798 19.2341 10.0559 17.0625C10.0559 17.0148 10.0622 16.9612 10.0672 16.9075C10.0735 16.8538 10.0798 16.8001 10.0798 16.7523L5.87988 13.9364C5.32743 14.2466 4.65569 14.4375 3.9601 14.4375C1.77539 14.4375 0 12.6716 0 10.5C0 8.32843 1.77539 6.5625 3.9601 6.5625C4.67955 6.5625 5.3764 6.7534 5.95145 7.08756L10.1037 4.41476C10.1037 4.346 10.0986 4.27166 10.0924 4.19445L10.0823 4.0616L10.0798 3.9375C10.0798 1.76593 11.8564 0 14.0399 0C16.2246 0 18 1.76593 18 3.9375ZM16.079 3.9375C16.079 2.8159 15.1674 1.90904 14.0399 1.90904C12.9111 1.90904 11.9996 2.8159 11.9996 3.9375C11.9996 5.0591 12.9111 5.96581 14.0399 5.96581C15.1674 5.96581 16.079 5.0591 16.079 3.9375ZM14.0399 15.034C15.1674 15.034 16.079 15.9409 16.079 17.0625C16.079 18.1841 15.1674 19.0908 14.0399 19.0908C12.9111 19.0908 11.9996 18.1841 11.9996 17.0625C11.9996 15.9409 12.9111 15.034 14.0399 15.034ZM1.91978 10.5C1.91978 11.6216 2.83133 12.5283 3.9601 12.5283C5.08761 12.5283 5.99916 11.6216 5.99916 10.5C5.99916 9.3784 5.08761 8.47154 3.9601 8.47154C2.83133 8.47154 1.91978 9.3784 1.91978 10.5Z"
                      fill="white"></path>
                  </svg>
                </router-link>
              </div>-->
              <!-- <div class="ml-auto btn-cos-container">
                <router-link to=""><img src="@/assets/img/svg/Create-your-own-Screening.svg" class="img-fluid cs-img">
                </router-link>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="container-fluid d-md-none"
      :class="checkFilterExist == false ? 'my-2' : ''"
      v-if="!checkFilterExist"
    >
      <div class="d-flex justify-content-center align-items-center">
        <div>
          <hr class="hr-line" />
        </div>
        <div class="filter-new-btn mx-2" @click="showFilterModal">
          <div>Filters</div>
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="sliders-h"
            class="svg-inline--fa fa-sliders-h fa-w-16"
            role="img"
            height="20"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              fill="#000"
              d="M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
            />
          </svg>
        </div>
        <div>
          <hr class="hr-line" />
        </div>
      </div>
    </section>
    <section
      class="container-fluid d-md-none"
      :class="checkFilterExist ? 'my-3' : ''"
    >
      <div class="filter-tabs" v-if="checkFilterExist">
        <div class="row">
          <div class="col-1">
            <span class="mr-3 ml-2" @click="showFilterModal">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="sliders-h"
                class="svg-inline--fa fa-sliders-h fa-w-16"
                role="img"
                height="17"
                width="17"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="#000"
                  d="M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
                />
              </svg>
            </span>
          </div>
          <div class="col-11">
            <ul class="list-inline filter-list mb-0">
              <span v-for="(data, index2) in showFilter" :key="index2">
                <li
                  class="list-inline-item active mr-2"
                  v-for="(item, index) in data.all_filter"
                  :key="index"
                  v-if="item.isActiveFilter == '1'"
                >
                  <div
                    class="d-flex justify-content-center align-items-center"
                    @click="getFilterVal(data, item, index2, index, '1')"
                  >
                    <div>{{ item.title }}</div>
                    <div class="filter-close">x</div>
                  </div>
                </li>
              </span>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container-fluid mb-5 mt-3 storylineSection">
        <div class="col-12">
          <div class="row">
            <div class="col-md-10 order-2 order-md-1">
              <p class="sTitle" v-if="screeningDetails.length == 0">
                You are welcome to create your own screening
              </p>
              <p class="sTitle" v-else-if="screeningDetails.length == 1">
                Existing Special Screenings
                <router-link to class="link">
                  (Available in
                  <span>{{ AvailableShowInCinema }}</span> Location)
                </router-link>
              </p>
              <p class="sTitle" v-else-if="screeningDetails.length > 1">
                Existing Special Screenings
                <router-link to class="link">
                  (Available in
                  <span>{{ AvailableShowInCinema }}</span> Locations)
                </router-link>
              </p>
            </div>
            <div
              class="col-md-2 order-1 order-md-2 mb-3 mb-md-0 d-none d-md-block"
            >
              <div class="filter-new-btn ml-auto" @click="showFilterModal">
                <div>Filters</div>
                <div>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="sliders-h"
                    class="svg-inline--fa fa-sliders-h fa-w-16"
                    role="img"
                    height="20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="#000"
                      d="M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 px-0 px-md-3">
          <div class="row">
            <div
              class="col-12 col-md-6 col-xl-4 mb-3"
              v-for="(singleScreening, screeningIndex) in screeningDetails"
              :key="screeningIndex"
            >
              <div
                class="
                  h-100
                  d-flex
                  justify-content-between
                  flex-column
                  createScreenBox
                "
              >
                <div
                  class="
                    d-flex
                    justify-content-between
                    align-items-center
                    py-3
                    px-3 px-md-4
                  "
                >
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <p class="mb-0 dtText">{{ singleScreening.day }}</p>
                    <div class="d-flex justify-content-center flex-column pl-1">
                      <p class="mb-0 mText">{{ singleScreening.monthName }}</p>
                      <p class="mb-0 dayText">{{ singleScreening.dayName }}</p>
                    </div>
                  </div>
                  <div>
                    <p class="mb-0 dtText">
                      {{
                        timeFormat(singleScreening.ss_start_show_time).split(
                          " "
                        )[0]
                      }}
                      <sup
                        class="tfText"
                        v-if="
                          timeFormat(singleScreening.ss_start_show_time).split(
                            ' '
                          ).length > 1
                        "
                        >{{
                          timeFormat(singleScreening.ss_start_show_time).split(
                            " "
                          )[1]
                        }}
                      </sup>
                    </p>
                  </div>
                </div>

                <div
                  class="
                    d-flex
                    justify-content-between
                    align-items-center
                    pb-3
                    px-3 px-md-4
                  "
                >
                  <div>
                    <p class="mb-0 tName">{{ singleScreening.cine_name }}</p>
                    <p class="mb-0 tAdd">
                      {{ singleScreening.screen_name }} -
                      {{ singleScreening.lang_name }} ({{
                        singleScreening.mf_name
                      }})
                    </p>
                    <p class="mb-0 tAdd">
                      {{ singleScreening.cine_address }}
                      {{
                        singleScreening.cine_location
                          ? `, ${singleScreening.cine_location}`
                          : ``
                      }}
                    </p>
                  </div>
                  <!-- <div>
                    <router-link
                      @click.native="onClickNext(singleScreening)"
                      v-if="singleScreening.ConfirmedStatus == false"
                      :to="{ name: 'seatLayout', params: { movieId: singleScreening.MovieID, categoryId: CategoryID, cinemaScheduleId: singleScreening.CinemaScheduleID }}"
                    >
                      <img src="@/assets/img/svg/next-red-arrow-icon.svg" class="img-fluid" />
                    </router-link>
                    <router-link
                      @click.native="onClickNext(singleScreening)"
                      v-if="singleScreening.ConfirmedStatus"
                      :to="{ name: 'seatLayout', params: { movieId: singleScreening.MovieID, categoryId: CategoryID, cinemaScheduleId: singleScreening.CinemaScheduleID }}"
                    >
                      <img src="@/assets/img/svg/next-green-arrow-icon.svg" class="img-fluid" />
                    </router-link>

                    <button class="btn btn-danger gogo-cus-btn d-none">Select Screeing</button>
                  </div>-->

                  <!-- @2019-09-03 Added By yogesh to show fully booked show -->
                  <div v-if="singleScreening.showType > 0">
                    <router-link
                      @click.native="onClickNext(singleScreening)"
                      v-if="singleScreening.showType == 2"
                      to
                    >
                      <img
                        src="@/assets/img/svg/next-red-arrow-icon.svg"
                        class="img-fluid"
                      />
                    </router-link>
                    <router-link
                      @click.native="onClickNext(singleScreening)"
                      v-if="singleScreening.showType == 1"
                      to
                    >
                      <img
                        src="@/assets/img/svg/next-green-arrow-icon.svg"
                        class="img-fluid"
                      />
                    </router-link>

                    <button class="btn btn-danger gogo-cus-btn d-none">
                      Select Screening
                    </button>
                  </div>

                  <div v-if="singleScreening.showType == 3">
                    <p class="mb-0 confText">Fully Booked</p>
                  </div>
                  <!-- @2019-09-03 Added By yogesh to show fully booked show-->
                </div>

                <div class="progressBarBox pt-3 pb-4 px-3 px-md-4">
                  <div
                    class="
                      d-flex
                      justify-content-between
                      align-content-center
                      pb-1
                    "
                  >
                    <p
                      v-if="singleScreening.showType === 2"
                      class="mb-0 confText"
                    >
                      NOT CONFIRMED
                    </p>
                    <p
                      v-if="singleScreening.showType == 1"
                      class="mb-0 confText"
                    >
                      CONFIRMED
                    </p>
                    <!-- <p v-if="singleScreening.ConfirmedStatus === false" class="mb-0 text-dark soldStatus"></p> -->
                    <!-- <p v-if="singleScreening.ConfirmedStatus" class="mb-0 soldStatus"> OUT OF  SEATS SOLD</p> -->
                  </div>
                  <div>
                    <b-progress
                      v-if="singleScreening.showType == 2"
                      :max="parseInt(singleScreening.screen_total_seats)"
                      class="proBar red mb-0"
                    >
                      <b-progress-bar
                        :value="singleScreening.booked_seats"
                      ></b-progress-bar>
                      <p class="mb-0 reqText m-auto pr-2">
                        Need
                        {{
                          parseInt(
                            singleScreening.min_seats -
                              singleScreening.booked_seats
                          )
                        }}
                        Seats to Confirm
                      </p>
                      <!-- <p :class="singleScreening.ConfirmedStatus ? 'd-none' : ''" class="mb-0 reqText ml-auto pr-2"
                        v-html="singleScreening.ExpiryMsg"></p> -->
                    </b-progress>
                    <b-progress
                      v-if="singleScreening.showType == 1"
                      :max="parseInt(singleScreening.screen_total_seats)"
                      class="proBar mb-0"
                    >
                      <b-progress-bar
                        :value="parseInt(singleScreening.screen_total_seats)"
                      >
                        <p class="mb-0 succ-text">
                          Available to Book
                          <!-- {{
                            parseInt(
                              singleScreening.screen_total_seats -
                                singleScreening.booked_seats
                            )
                          }}
                          Seats Left -->
                        </p>
                      </b-progress-bar>
                    </b-progress>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6 col-xl-4 mb-3">
              <router-link
                :to="{
                  name: 'specialScreening',
                  params: {
                    movieId: MovieID,
                    categoryId: 2,
                    content_lang_id: content_lang_id,
                  },
                }"
              >
                <div
                  class="
                    h-100
                    d-flex
                    justify-content-center
                    flex-column
                    createBlankBox
                  "
                >
                  <div class="text-center pb-2">
                    <img
                      src="@/assets/img/svg/add-red-icon.svg"
                      class="img-fluid"
                    />
                  </div>
                  <p class="text-center gogo-dtxt">Create Your Own Screening</p>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-light py-5 py-md-4">
      <div class="container-fluid my-md-4 storylineSection">
        <div class="row">
          <div class="col-md-6 pl-3 pl-xl-5">
            <p class="pb-2 sTitle">Storyline</p>
            <p class="sText">{{ movieDetails.mc_plot }}</p>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12 text-left d-flex-inline mb-5">
                <p class="pb-2 sTitle d-inline">Director : &nbsp;</p>

                <div class="list-inline sList d-inline fs-14">
                  {{ Directors }}
                  <!-- <div
                    v-for="(director, directorKey) in movieDetails.Directors"
                    :key="directorKey"
                    class="list-inline-item text-center"
                  >
                    
                    <p class="mb-0 sName">{{ director.mcc_cast_name }}</p>
                  </div> -->
                </div>
              </div>

              <div class="col-md-12 text-left d-flex-inline mb-5">
                <p class="pb-2 sTitle d-inline">Cast : &nbsp;</p>

                <div class="list-inline sList d-inline">
                  {{ Actors }}
                  <!-- <div
                    v-for="(actor, actorKey1) in movieDetails.Actors"
                    :key="actorKey1"
                    class="list-inline-item text-center"
                  >
                    
                    <p class="mb-0 sName">{{ actor.mcc_cast_name }}</p>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CREATE YOUR OWN SCREENING SLIDER -->
    <section>
      <div class="container-fluid my-4">
        <OwnScreening />
      </div>
    </section>

    <!--FILTER MODAL -->
    <b-modal
      hide-header-close
      hide-footer
      ref="filterModalRef"
      id="filterModal"
      title="Choose Any Filter"
      modal-class="welcome-b"
    >
      <button
        type="button"
        @click="hideFilter()"
        aria-label="Close"
        class="close"
      >
        ×
      </button>
      <div class="col-12 loginmodal p-3 p-md-4">
        <div
          class="filter-tabs"
          v-for="(movie, index1) in showFilter"
          :key="index1"
        >
          <p class="border-bottom pb-2">{{ movie.filter_name }}</p>
          <ul class="list-inline">
            <li
              class="list-inline-item"
              v-for="(data, index2) in movie.all_filter"
              :key="index2"
              v-if="data.value"
              @click="getFilterVal(movie, data, index1, index2, '2')"
              :class="data.isActive == '1' ? 'active' : ''"
            >
              {{ data.title }}
            </li>
          </ul>
        </div>
        <div class="row proceed-btn-filter text-center mt-5 mx-auto">
          <div class="col-6 mx-0 mx-auto">
            <button type="button" name id class="btn" @click="resetFilter">
              Reset
            </button>
          </div>
          <div class="col-6 mx-0 mx-auto">
            <button
              type="button"
              name
              id
              class="btn apply-filter"
              @click="applyFilter"
            >
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";
import { TokenService, CountryService } from "@/services/storage.service";
import MainServices from "@/services/mainService.js";
import moment from "moment";
import { URL_BASE } from "@/helper/constants";

//   import NowShowing from "@/components/partials/nowShowingSlider.vue";
//   import SpecialScreenings from "@/components/partials/SpecialScreeningsSlider.vue";
import OwnScreening from "@/components/partials/OwnScreeningSlider.vue";
//   import UpcomingFestivals from "@/components/partials/UpcomingMiniFestivals.vue";

export default {
  name: "createScreen",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    Slick,
    OwnScreening,
  },
  computed: {
    Actors() {
      let TempArray = [];
      this.movieDetails.Actors.map((x) => {
        TempArray.push(x.mcc_cast_name);
      });
      return TempArray.join(", ");
    },
    Directors() {
      let TempArray = [];
      this.movieDetails.Directors.map((x) => {
        TempArray.push(x.mcc_cast_name);
      });
      return TempArray.join(", ");
    },
    checkFilterExist() {
      let obj = false;
      this.showFilter.map((x) => {
        x.all_filter.map((y) => {
          if (y.isActiveFilter == "1") {
            obj = true;
          }
        });
      });
      return obj;
    },
  },

  data() {
    return {
      showFilter: [],
      poster: "",
      checkAmPm: true,
      dateTimeSlider: {
        dots: false,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 9,
        slidesToScroll: 6,
        dots: false,
        responsive: [
          {
            breakpoint: 1900,
            settings: {
              slidesToShow: 7,
              slidesToScroll: 4,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3.1,
              slidesToScroll: 3,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2,
            },
          },
        ],
      },
      movieDetails: {},
      screeningDetails: [],
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      movie_format: [],
      movie_language: [],
      cinema_name: [],
      sub_regions: [],
      show_time: [],
      confirm: [],
      content_lang_id: 0,
      AvailableShowInCinema: 0,
    };
  },
  beforeMount() {
    this.MovieID = this.$route.params.movie_id;
    this.content_lang_id = this.$route.params.content_lang_id;
    this.showLoading();
    this.fetchMovieDetails();
    this.getConfirmedMovie();
    // this.fetchScreeningDetails();
    // this.fetchFilterDetails();
  },
  watch: {
    $route(to, from) {
      this.MovieID = this.$route.params.movie_id;
      this.content_lang_id = this.$route.params.content_lang_id;
      this.fetchMovieDetails();
      // this.fetchScreeningDetails();
    },
  },
  methods: {
    GetYear(date) {
      return moment(date).format("YYYY");
    },
    resetFilter: function () {
      this.showFilter.map((x) => {
        this[x.filter_key] = [];
      });

      this.showFilter = [];
      this.getConfirmedMovie();
      this.hideFilter();

      // this.fetchScreeningDetails();
      // this.fetchFilterDetails();
    },
    getFilterVal(movie, data, index1, index2, val) {
      let i = this[movie.filter_key].indexOf(data.value);
      this[movie.filter_key] = [];
      this.showFilter[index1].all_filter.map((y) => {
        y.isActive = "0";
        y.isActiveFilter = "0";
      });
      if (i >= 0) {
        if (val == "1") {
          this.getConfirmedMovie();
        }
        return false;
      }

      this.showFilter[index1].all_filter.map((y) => {
        y.isActive = "0";
        y.isActiveFilter = "0";
      });

      setTimeout((x) => {
        if (i >= 0) {
          this[movie.filter_key].splice(i, 1);
          this.showFilter[index1].all_filter[index2].isActive = "0";
          if (val == "1") {
            this.showFilter[index1].all_filter[index2].isActiveFilter = "0";
          }
        } else {
          this[movie.filter_key].push(data.value);
          this.showFilter[index1].all_filter[index2].isActive = "1";
        }
        if (val == "1") {
          // this.fetchScreeningDetails();
        }
      }, 100);

      // let i = this[movie.filter_key].indexOf(data.value);
      // if (i >= 0) {
      //   this[movie.filter_key].splice(i, 1);
      //   this.showFilter[index1].all_filter[index2].isActive = "0";
      // } else {
      //   this[movie.filter_key].push(data.value);
      //   this.showFilter[index1].all_filter[index2].isActive = "1";
      // }
    },
    showFilterModal() {
      this.$refs["filterModalRef"].show();
    },
    hideFilter() {
      this.$refs["filterModalRef"].hide();
    },
    // fetchFilterDetails: function() {
    //   let payload = {
    //     MovieID: this.MovieID
    //   };
    //   makeRequest("/GetShowFilters/", "POST", null, payload)
    //     .then(response => {
    //       const { error, res } = response;
    //       res.data.Filters.map(x => {
    //         x.all_filter.map(y => {
    //           y["isActive"] = "0";
    //           y["isActiveFilter"] = "0";
    //         });
    //       });
    //       this.showFilter = res.data.Filters;
    //     })
    //     .catch(error => {
    //       console.log("Error", error);
    //     });
    // },
    fetchMovieDetails: function () {
      let payload = {
        movie_id: this.MovieID,
        content_lang_id: this.content_lang_id,
        category_id: 1,
        cinema_id: this.cinema_id,
        md_for_ondemand: "Y",
        guest_user_id: null,
        cust_id: 1,
      };
      MainServices.GetMovieDetails(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            // console.log("responseMovie", response);
            this.movieDetails = data.Records[0];
            let trailer = data.Records[0].trailer_array.filter((x) => {
              return x.lang_id == 1;
            });
            let directors = data.Records[0].castCrewDetails.filter((z) => {
              return z.crew_title.includes("Director");
            });
            let Actors = data.Records[0].castCrewDetails.filter((z) => {
              return z.crew_title.includes("Actor");
            });
            this.poster = data.Records[0].mp_poster_url
              ? URL_BASE + data.Records[0].mp_poster_url
              : data.Records[0].md_thumbnail_url;
            // console.log(Actors, directors);
            this.movieDetails["Actors"] = [];
            this.movieDetails["Directors"] = [];
            if (directors.length > 0) {
              this.movieDetails["Directors"] = directors[0]["Crew"];
            }
            if (Actors.length > 0) {
              this.movieDetails["Actors"] = Actors[0]["Crew"];
            }
            if (trailer.length > 0) {
              this.movieDetails.original_trailer = trailer[0].mt_link;
            }
            this.hideLoading();
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    getConfirmedMovie: function () {
      let payload = {
        movie_id: this.MovieID,
        cinema_id: "",
      };
      if (this.showFilter.length > 0) {
        this.showFilter.map((x) => {
          if (this[x.filter_key].length > 0) {
            payload[x.query_id] = this[x.filter_key][0];
          }
        });
      }
      MainServices.getMovieConfirmedList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            // console.log("responseMovieConfirmed", response);
            if (data.MovieListArrayNew.length > 0) {
              this.AvailableShowInCinema =
                data.MovieListArrayNew[0].CinemaList.length;

              if (this.showFilter.length == 0) {
                data.FilterData.map((x) => {
                  x.all_filter.map((y) => {
                    y["isActive"] = "0";
                    y["isActiveFilter"] = "0";
                  });
                });
                this.showFilter = data.FilterData;
              }
            } else {
              this.AvailableShowInCinema = 0;
            }

            if (data.Records.data.length > 0) {
              this.screeningDetails = data.Records.data;
            } else {
              this.screeningDetails = [];
            }
            this.hideLoading();
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    applyFilter() {
      this.showFilter.map((x) => {
        x.all_filter.map((y) => {
          if (y.isActive == "1") {
            y.isActiveFilter = "1";
          }
        });
      });

      this.getConfirmedMovie();
      this.hideFilter();
    },
    fetchScreeningDetails: function () {
      let payload = {
        MovieID: this.MovieID,
        Version: "1",
      };
      if (this.showFilter.length > 0) {
        this.showFilter.map((x) => {
          if (this[x.filter_key].length > 0) {
            payload[x.filter_key] = this[x.filter_key].toString();
          }
        });
      }
      makeRequest("/GetSpecialScreening/", "POST", null, payload)
        .then((response) => {
          const { error, res } = response;
          this.hideLoading();
          this.screeningDetails = res.data;
          this.screeningDetails.map((date) => {
            let _CinemaTimings;
            if (date.hasOwnProperty("CinemaTimingsNew")) {
              _CinemaTimings = tConvert(date.CinemaTimingsNew);
            } else {
              _CinemaTimings = tConvert(date.CinemaTimings);
            }
            if (date.hasOwnProperty("ShowAmPm")) {
              // console.log("fsdfdsfdsfdsf");
              this.checkAmPm = date.ShowAmPm;
            }
            date.CinemaTimings = date.CinemaTimings;
            date.ampm = _CinemaTimings.split(" ")[1];
            let parts = date.MovieDate.split("-"),
              year = parseInt(parts[0], 10),
              month = parseInt(parts[1], 10) - 1, // NB: month is zero-based!
              day = parseInt(parts[2], 10);
            let date1 = new Date(year, month, day);
            date.day = this.days[date1.getDay()];
            date.date = date1.getDate();
            date.year = year;
            date._CinemaTimings = date.CinemaTimings;
            date.month = this.months[date1.getMonth()].substring(0, 3);
            date.SeatsBooked = parseInt(date.SeatsBooked);
            date.SeatsLeft =
              parseInt(date.TotalSeat) - parseInt(date.SeatsBooked);
            // console.log(date.SeatsLeft, "test");

            return date;
          });

          this.$refs["filterModalRef"].hide();
        })
        .catch((error) => {
          console.log("Error", error);
        });
      function tConvert(time) {
        // Check correct time format and split into components
        time = time
          .toString()
          .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    onClickNext: function (cinemaDetails, CategoryID) {
      console.log({ cinemaDetails });
      let showDetails = {
        CinemaName: cinemaDetails.cine_name,
        CinemaAddress: cinemaDetails.cine_address,
        ShowDateTime:
          cinemaDetails.monthName +
          " " +
          cinemaDetails.day +
          ", " +
          cinemaDetails.Year +
          " | " +
          cinemaDetails.ss_start_show_time,
      };
      // let country = CountryService.getCountry();
      this.secureStore.set("STD", showDetails);

      const query = {};

      if (cinemaDetails.vista_schedule_id)
        query.vista_schedule_id = cinemaDetails.vista_schedule_id;
      if (cinemaDetails.rts_performance_id)
        query.rts_performance_id = cinemaDetails.rts_performance_id;

      query.rts_performance_id = this.$router.push({
        name: "seatLayout",
        params: {
          ss_id: cinemaDetails.ss_id,
          screen_id: cinemaDetails.screen_id,
          md_id: cinemaDetails.movie_details_id,
        },
        query,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/createScreen.vue